export default __webpack_public_path__ + "static/media/gallery_00.90e0da29.jpg";